import { commonGuard, adminGuard } from "../func"

const groupRouter = {
  path: "groups",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "group-root",
      beforeEnter: commonGuard,
      redirect: { name: "groups" },
      component: () => import("@/components/groups/index.vue"),
      children: [
        {
          path: "",
          name: "groups",
          beforeEnter: commonGuard,
          component: () => import("@/components/groups/table.vue"),
        },
        {
          path: "detail",
          redirect: { name: "groups" },
          component: { template: "<router-view></router-view>" },
          beforeEnter: commonGuard,
          children: [
            {
              path: ":groupPk",
              name: "group-detail",
              beforeEnter: commonGuard,
              component: () => import("@/components/groups/detail.vue"),
              props: true,
            },
          ],
        },
        {
          path: ":groupPk",
          name: "groups-sub",
          beforeEnter: commonGuard,
          component: () => import("@/components/groups/table.vue"),
          props: true,
        },
      ],
    },
  ],
}

export default groupRouter
